import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import { getPrincipalMessage } from '../Service/Api';

const removeHtmlTags = (str = '') => str.replace(/<[^>]*>/g, '');

const Message = () => {
  const [messages, setMessages] = useState({});

  useEffect(() => {
    const fetchMessages = async () => {
      const res = await getPrincipalMessage();

      const grouped = {
        Chairman: res.filter(item => item.category === 'Chairman'),
        Bishop: res.filter(item => item.category === 'Bishop'),
        Director: res.filter(item => item.category === 'Director'),
        Principal: res.filter(item => item.category === 'Principal'),
      };

      setMessages(grouped);
    };

    fetchMessages();
  }, []);

  const renderMessage = (category, fallback, link) => {
    const data = messages[category] || [];

    if (data.length > 0) {
      return data.map(item => (
        <React.Fragment key={item._id}>
          <div className='message_img chairman orderd-1'>
            <LazyLoad>
              <img
                src={`https://webapi.entab.info/api/image/${item.attachments?.[0]}`}
                className='img-fluid msg-img'
                alt={item.name}
              />
            </LazyLoad>
            <LazyLoad>
              <img
                src='https://webapi.entab.info/api/image/SFSAP/public/Images/message-btn.gif'
                className='message-btn'
                alt="message button"
              />
            </LazyLoad>
          </div>

          <div className='message_content orderd-2'>
            <h5>{item.name}</h5>
            <h6>{item.designation}</h6>
            <p>{removeHtmlTags(item.message)}</p>
            <button className='button'>
              <Link to={link}>VIEW ALL</Link>
            </button>
          </div>
        </React.Fragment>
      ));
    }

    return (
      <>
        <div className='message_img chairman orderd-1'>
          <LazyLoad>
            <img src={fallback.image} className='img-fluid msg-img' alt={fallback.name} />
          </LazyLoad>
        </div>
        <div className='message_content orderd-2'>
          <h5>{fallback.name}</h5>
          <h6>{fallback.designation}</h6>
          <p>{fallback.message}</p>
          <button className='button'>
            <Link to={link}>VIEW ALL</Link>
          </button>
        </div>
      </>
    );
  };

  return (
    <div className='message_blk'>
      <div className='d-flex'>

        {renderMessage('Chairman', {
          image: 'https://webapi.entab.info/api/image/SFSAP/public/Images/chairman.png',
          name: 'Most Rev. Fr. Thomas Kolenchery',
          designation: 'Chairman',
          message: 'Message from the Chairman.'
        }, '/chairman')}

        {renderMessage('Bishop', {
          image: 'https://webapi.entab.info/api/image/SFSAP/public/Images/bishop.png',
          name: 'Most Rev. Jose Sebastian T',
          designation: 'Bishop',
          message: 'Message from the Bishop.'
        }, '/bishop')}

        {renderMessage('Director', {
          image: 'https://webapi.entab.info/api/image/SFSAP/public/Images/director.png',
          name: 'REV. FR. MATHEW JOSEPH MANALUMPARAYIL',
          designation: 'Director',
          message: 'Director message fallback.'
        }, '/director')}

        {renderMessage('Principal', {
          image: 'https://webapi.entab.info/api/image/SFSAP/public/Images/principal.png',
          name: 'SR. SOOSAI MARY',
          designation: 'Principal',
          message: 'Principal message fallback.'
        }, '/principal')}

      </div>
    </div>
  );
};

export default Message;
